import { useCallback, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import { Button, message, Popover } from 'antd';

const ShareButton = (): ReactNode => {
  const { t } = useTranslation();

  const onShare = useCallback((): void => {
    navigator.clipboard
      .writeText(location.href)
      .then((): void => {
        message.success(
          <ShareMessage>
            {t('message.shareLinkCopied1')}
            <br />
            {t('message.shareLinkCopied2')}
          </ShareMessage>
        );
      })
      .catch((): void => {
        message.error(
          <ShareMessage>{t('message.unexpectedError')}</ShareMessage>
        );
      });
  }, [t]);

  return (
    <Popover
      content={t('copySharableUrlInClipboard')}
      placement="bottomLeft"
      trigger="hover"
    >
      <StyledButton type="text" onClick={onShare}>
        <FontAwesomeIcon icon={faShare} style={{ fontSize: '14px' }} />
        {t('share')}
      </StyledButton>
    </Popover>
  );
};

const StyledButton = styled(Button)`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
`;

const ShareMessage = styled.div`
  display: inline-block;
  vertical-align: top;
  text-align: start;
`;

export { ShareButton };
